import Avvir from "avvir";

import pipelinesForFloorLoaded, { PipelinesForFloorLoadedEvent } from "../../../events/loaded/floors/pipelines_for_floor_loaded";
import getPipelineRunningProcessesForFloor from "../../../services/getters/running_processes_getters/get_pipeline_running_processes_for_floor";
import { AvvirThunk } from "../../make_eventful_action";
import Pipeline from "../../../models/domain/pipeline";

const loadPipelinesForFloor = (projectId: string, floorId: string): AvvirThunk<Promise<Pipeline[]>, PipelinesForFloorLoadedEvent> => {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.user;
    return Avvir.api.pipelines.getFloorPipelines({ projectId, floorId }, user)
      .then((pipelines) => {
        dispatch(pipelinesForFloorLoaded(projectId, floorId, pipelines));
        return getPipelineRunningProcessesForFloor(getState(), {});
      });
  };
};

export default loadPipelinesForFloor;
